// services/receivablePdf.service.ts

import { receivablePdfApi } from "../../api";

const ReceivablePdfService = {
    /**
     * 📄 Descarga el estado de cuenta PDF
     * de una cuenta por cobrar.
     *
     * GET /api/pdf/receivables/{id}
     */
    download: async (
        id: number
    ): Promise<{
        blob: Blob;
        fileName: string | null;
    }> => {
        const response =
            await receivablePdfApi.fetchBlob(`/${id}`);

        return {
            blob: response.data,
            fileName:
                response.fileName ||
                `estado_cuenta_${id}.pdf`,
        };
    },
};

export default ReceivablePdfService;